import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Company } from '../../../auth/models/company';
import { ActivatedRoute } from '@angular/router';
import {Tender} from '../../models/tender';
import {Supplier} from '../../models/supplier';

@Component({
    selector: 'jft-tender-supplier-input-bid',
    templateUrl: './tender-supplier-input-bid.component.html',
    styleUrls: ['./tender-supplier-input-bid.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TenderSupplierInputBidComponent implements OnInit {

    public suppliers: Company[] = [];
    public tender: Tender;
    public supplier: Supplier;

    constructor(
        private route: ActivatedRoute
    ) {
    }

    public ngOnInit() {
        let data = this.route.snapshot.data;
        this.tender = data['tender'];
        this.supplier = data['supplier'];
    }

}
